import Dice from '../../../Components/Dice/Dice';
import HeaderLayout from '../../../Layout/HeaderLayout';

export default function DiceMaster() {

    return (
        <div>
            <HeaderLayout currentPage="dice" hamburger={true} isMaster={true}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100.03 100"><g ><path fill="#fff" d="m85.4,14.48L42.93,0,0,33.38l14.43,51.93,42.91,14.69,42.69-33.13-14.63-52.39Zm-1.67,20.46l13.99,30.78-28.98,15.22,14.98-46Zm-17.27,46.04l-32.19-37.04,47.68-10.52-15.49,47.55Zm27.87-27.93l-9.67-21.28.8-10.51,8.88,31.79Zm-10.63-37.24l-1.07,14.08L49.25,4.06l34.45,11.75ZM44.08,2.8l36.99,28.62-47.33,10.44L44.08,2.8Zm-2.49.96l-10.09,38.15L3.84,33.12,41.6,3.76ZM3.13,35.16l27.69,8.8-14.99,36.92L3.13,35.16Zm29.47,10.16l31.97,36.78-47.31,1,15.34-37.78Zm-10.85,39.85l43.19-.92-7.94,12.98-35.25-12.06Zm39.72,8.89l6.19-10.12,21.17-11.12-27.36,21.23Z" /></g></svg>
                <span>D20</span>
            </HeaderLayout>

            <Dice nbSides={20} isMaster={true} />
        </div>
    );
}
